import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { MultipleSelectionListItem } from '@app/shared/models/multiple-selection-list.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'app-multiple-selection-list',
    templateUrl: './multiple-selection-list.component.html',
    styleUrls: ['./multiple-selection-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MultipleSelectionListComponent<T> implements OnInit {
    @Input() title: string;
    @Input() data$: Observable<MultipleSelectionListItem<T>[]>;
    @Output() selectionChange: EventEmitter<MultipleSelectionListItem<T>> = new EventEmitter<
        MultipleSelectionListItem<T>
    >();

    selectionCounter = 0;

    ngOnInit() {
        this.data$
            .pipe(
                filter((data) => !!data),
                take(1)
            )
            .subscribe(
                (data) => (this.selectionCounter = data.filter((item) => item.selected).length)
            );
    }

    onItemSelectionChangeEvent(item: MultipleSelectionListItem<T>, event: MatCheckboxChange) {
        event.checked ? this.selectionCounter++ : this.selectionCounter--;

        this.selectionChange.emit({
            ...item,
            selected: event.checked,
        });
    }
}
